import { useState } from "react";

export default function SubirFirma() {
  const [file, setFile] = useState(null);
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("firma", file);
    formData.append("password", password);

    const res = await fetch(
  process.env.REACT_APP_API_URL + "/api/usuarios/firma",
  {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: formData,
  }
);

    const data = await res.json();
    alert(data.message || "Error");
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>Subir firma electrónica</h2>

      <input
        type="file"
        accept=".p12"
        onChange={(e) => setFile(e.target.files[0])}
        required
      />

      <input
        type="password"
        placeholder="Contraseña de la firma"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />

      <button type="submit">Subir firma</button>
    </form>
  );
}
